import { Box, Image, Text, Icon } from '@chakra-ui/react'
import React from 'react'
import { useIntl } from 'react-intl'
import { formatNumber } from '../../helpers/crud-helper/helpers'

interface ICardItemProps {
    image: string
    title: string
    subTitle: string
    price?: number | null
    layout?: CardLayout
    network?: string
    contractAddress?: string
    tokenId?: string | number
    currency?: string
}

export enum CardLayout {
    COZY = 'cozy',
    COMPACT = 'compact',
}

export const CardItem = (props: ICardItemProps) => {
    const { image, title, subTitle, price, layout = CardLayout.COZY, network, contractAddress, tokenId, currency } = props
    const intl = useIntl()
    const updatedImageSrc = image?.includes('ipfs.io') ? image?.replace('ipfs.io', 'cloudflare-ipfs.com') : image
    const cardSize = {
        [CardLayout.COZY]: { base: 'calc(50% - 6px)', lg: 'calc(25% - 24px)' },
        [CardLayout.COMPACT]: { base: 'calc(50% - 6px)', lg: 'calc(20% - 25.6px)' },
    }
    const imgHeight = {
        [CardLayout.COZY]: { base: '173px', lg: '304px' },
        [CardLayout.COMPACT]: { base: '173px', lg: '230' },
    }
    const getHost = () => (window.location.protocol + "//" + window.location.host)

    return (
        <Box borderRadius={'6px'} w={cardSize[layout]} bg="#FFFFFF0A" maxWidth={{ base: '200px', lg: '304px' }}>
            <a href={`${getHost()}/assets/${network}/${contractAddress}/${tokenId}`}>
                <Image borderTopRadius={'6px'} objectFit={'cover'} w={'100%'} h={imgHeight[layout]} src={updatedImageSrc} />
                <Box p={{ base: '16px', lg: CardLayout.COZY === layout ? '24px' : '16px' }}>
                    <Box marginBottom={'4px'}>
                        <Text fontSize={{ base: '16px' }} fontWeight={700} noOfLines={1} title={title}>
                            {title}
                        </Text>
                    </Box>
                    <Box display={'flex'} alignItems={'center'} justifyContent={'start'} gap={'8px'} title={subTitle}>
                        <Text fontSize={{ base: '16px' }} fontWeight={700} color={'#808489'} noOfLines={1}>
                            {subTitle}
                        </Text>
                        <Box display={'flex'} alignItems={'center'} justifyContent={'center'} w={'16px'} h={'16px'} cursor={'pointer'} >
                            <Icon display={'block'} h={'16px'} w={'16px'} viewBox="0 0 16 16" fill="none" color="#2FB551">
                                <path
                                    d="M14.1163 6.42625C13.8806 6.18 13.6369 5.92625 13.545 5.70312C13.46 5.49875 13.455 5.16 13.45 4.83187C13.4406 4.22187 13.4306 3.53062 12.95 3.05C12.4694 2.56937 11.7781 2.55937 11.1681 2.55C10.84 2.545 10.5013 2.54 10.2969 2.455C10.0744 2.36312 9.82 2.11937 9.57375 1.88375C9.1425 1.46937 8.6525 1 8 1C7.3475 1 6.85812 1.46937 6.42625 1.88375C6.18 2.11937 5.92625 2.36312 5.70312 2.455C5.5 2.54 5.16 2.545 4.83187 2.55C4.22187 2.55937 3.53062 2.56937 3.05 3.05C2.56937 3.53062 2.5625 4.22187 2.55 4.83187C2.545 5.16 2.54 5.49875 2.455 5.70312C2.36312 5.92562 2.11937 6.18 1.88375 6.42625C1.46937 6.8575 1 7.3475 1 8C1 8.6525 1.46937 9.14187 1.88375 9.57375C2.11937 9.82 2.36312 10.0737 2.455 10.2969C2.54 10.5013 2.545 10.84 2.55 11.1681C2.55937 11.7781 2.56937 12.4694 3.05 12.95C3.53062 13.4306 4.22187 13.4406 4.83187 13.45C5.16 13.455 5.49875 13.46 5.70312 13.545C5.92562 13.6369 6.18 13.8806 6.42625 14.1163C6.8575 14.5306 7.3475 15 8 15C8.6525 15 9.14187 14.5306 9.57375 14.1163C9.82 13.8806 10.0737 13.6369 10.2969 13.545C10.5013 13.46 10.84 13.455 11.1681 13.45C11.7781 13.4406 12.4694 13.4306 12.95 12.95C13.4306 12.4694 13.4406 11.7781 13.45 11.1681C13.455 10.84 13.46 10.5013 13.545 10.2969C13.6369 10.0744 13.8806 9.82 14.1163 9.57375C14.5306 9.1425 15 8.6525 15 8C15 7.3475 14.5306 6.85812 14.1163 6.42625ZM10.8538 6.85375L7.35375 10.3538C7.30731 10.4002 7.25217 10.4371 7.19147 10.4623C7.13077 10.4874 7.06571 10.5004 7 10.5004C6.93429 10.5004 6.86923 10.4874 6.80853 10.4623C6.74783 10.4371 6.69269 10.4002 6.64625 10.3538L5.14625 8.85375C5.05243 8.75993 4.99972 8.63268 4.99972 8.5C4.99972 8.36732 5.05243 8.24007 5.14625 8.14625C5.24007 8.05243 5.36732 7.99972 5.5 7.99972C5.63268 7.99972 5.75993 8.05243 5.85375 8.14625L7 9.29313L10.1462 6.14625C10.1927 6.09979 10.2479 6.06294 10.3086 6.0378C10.3692 6.01266 10.4343 5.99972 10.5 5.99972C10.5657 5.99972 10.6308 6.01266 10.6914 6.0378C10.7521 6.06294 10.8073 6.09979 10.8538 6.14625C10.9002 6.1927 10.9371 6.24786 10.9622 6.30855C10.9873 6.36925 11.0003 6.4343 11.0003 6.5C11.0003 6.5657 10.9873 6.63075 10.9622 6.69145C10.9371 6.75214 10.9002 6.8073 10.8538 6.85375Z"
                                    fill="#2FB551"
                                />
                            </Icon>
                        </Box>
                    </Box>
                    <Box
                        marginTop={{ base: '12px', lg: '16px' }}
                        display={'flex'}
                        justifyContent={'space-between'}
                        flexDirection={{ base: 'column', lg: 'row' }}
                    >
                        <Text fontSize={{ base: '14px' }} fontWeight={400} color={'#808489'}>
                            {intl.formatMessage({ id: 'CARD.LAST_SALE' })}
                        </Text>
                        <Text fontSize={{ base: '14px', lg: CardLayout.COZY === layout ? '16px' : '14px' }} fontWeight={700} color={'#FFFFFF'}>
                            {formatNumber(price, 0.001)} {currency}
                        </Text>
                    </Box>
                </Box>
            </a>
        </Box>
    )
}
